var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('canvas',{attrs:{"id":'canvas-' + _vm.index,"width":_vm.page.paperType.width,"height":_vm.page.paperType.height}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }